<template>
  <div class="OrderPayment">
      <div class="OrderPayment__header">
        <div class="OrderPayment__header__left">
          <div class="OrderPayment__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
           <div class="OrderPayment__header__left__filter">
            <dropdown-list class="dropdownDoc__item" @selected="selectedProgress" :valueDisplay="selectedOrderStatusValue" :list="progressList" labelButton="All Progress" />
          </div>
          <div class="OrderPayment__header__left__filter">
            <dropdown-list class="dropdownDoc__item" @selected="selectedPayment" :valueDisplay="selectedPaymentValue" :list="paymentList" labelButton="All Payment" />
          </div>
          <dropdown-2-level v-if="isShowBulkAction" @selected="selectedBulkAction"  :lists="bulkAction" labelButton="Bulk Action"/>
          <div v-if="filtered" class="reset">
            <button class="btn-regular primary" @click="resetFilter">Reset</button>
          </div>
        </div>
        <div class="OrderPayment__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort  :labelButton="`All Filter`"
            :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
      <adx-table text="Tooltip button" 
        :items.sync="data" 
        :loading.sync= "isLoading" 
        :isEmpty.sync="isEmpty"
        :titleText="`View Detail`"
        @selected="selected" 
        @setItem="setItem" 
        @selectedCheckbox="selectedCheckbox"
        @selectedRow="selectedRow">
      </adx-table>

    <div class="total_order" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Orders</div>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      @change-page="changePage"
      :max-page="maxPage"
      :selected-page="currentPage"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import Dropdown2Level from '@/components/Dropdown/Dropdown2Level'
import DropdownList from '@/components/Dropdown/ListDropdown'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-payment-order',
  components: {
    DropdownList,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-list': ListDropdown,
    'adx-table': table, LabelStatus,
    'dropdown-2-level': Dropdown2Level
  },
  props: {

  },
  data() {
    return {
      item: null,
      items: [],
      menuOption:[{
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": []
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        }],
      isShowBulkAction:false,
      selectedItems:[],
      currentPage: 1,
      count: 0,
      maxPage: 1,
      searchBoxValue: '',
      selectedSortValue: 'last_updated',
      selectedOrderStatusValue:'',
      selectedOrderStatusLabel:'',
      selectedPaymentValue:'',
      selectedPaymentLabel:'',
      selectedCampaignStatus:'',
      selectedCampaignLabel:'',
      selectStatus: '',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      bulkAction: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": []
        }
      ],
      data: {
        checkbox: true,
        head: [
          {
            title: "ID",
            type: "text-value"
          },
          {
            title: "COMPANY NAME",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "PAYMENT",
            type: "statuslabel"
          },
          {
            title: "DUE DATE",
            type: "date"
          },
          {
            title: "START DATE",
            type: "date"
          },
          {
            title: "PROGRESS",
            type: "statuslabel"
          },
        ],
        body: []
      },
      paymentList: [
        {
          id: 99,
          label: 'All',
          value: null
        },
        {
          id: 0,
          item : 'PENDING',
          label: 'Pending',
          value: "0"
        },
        {
          id: 1,
          item : 'PAID',
          label: 'Paid',
          value: "1"
        },
        {
          id: 2,
          item : 'DOWNPAYMENT',
          label: 'DownPayment',
          value: "2"
        },
        {
          id: 3,
          item : 'PARTIALLY',
          label: 'Partially',
          value: "3"
        },
        {
          id: 4,
          item : 'AFTERPAY',
          label: 'AfterPay',
          value: "4"
        },
      ],
      progressList: [
        {
          id: 99,
          label: 'All Progress',
          value: null
        },
        {
          id: 0,
          item: 'LEAD',
          label: 'Lead',
          value: "lead"
        },
        {
          id: 1,
          item: 'VERIFYING',
          label: 'Verifying',
          value: "verifying",
        },
        {
          id: 2,
          item: 'DESIGNING',
          label: 'Designing',
          value: "designing"
        },
        {
          id: 3,
          item: 'DESIGN APPROVAL',
          label: 'Design Approval',
          value: "designapproval"
        },
        {
          id: 4,
          item: 'PRINTING',
          label: 'Printing',
          value: "printing"
        },
        {
          id: 5,
          item: 'PRINTING APPROVAL',
          label: 'Printing Approval',
          value: "printapproval"
        },
        {
          id: 6,
          item: 'WRAPPING',
          label: 'Wrapping',
          value: "wrapping"
        },
        {
          id: 7,
          item: 'DONE',
          label: 'Done',
          value: "done"
        }
      ],
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedOrderStatusValue || this.selectedPaymentValue) {
        filtered = true
      }
      return filtered
    },
    getFilterParams: function () {
      const params = {
        sort: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
        orderStatus: this.selectedOrderStatusValue || undefined,
        paymentStatus: this.selectedPaymentValue || undefined,
        campaignStatus: this.selectedCampaignStatus || undefined
      }
      return params
    },
    getDataRange: function(){
      return (this.count%15===0 || this.currentPage===1) && this.count>15?this.currentPage*15:(this.currentPage*15-15)+(this.count%15)
    },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    isLoading: function(){
      return this.$apollo.loading || false
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function (){
      this.$nextTick(function(){
        this.currentPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    }, 500),
    selectedSortValue: function(newVal, oldVal){
      if(newVal!=oldVal){
        this.currentPage = 1
        this.selectedSortValue = newVal
        this.$apollo.queries.busOrdersPage.refetch()
      }
    },
    selectedOrderStatusValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    },
    selectedPaymentValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    },
  },
  beforeCreate() {
    
  },
  created() {
    this.getProgressList()
  },
  apollo:{
    busOrdersPage:{
      query:require('@/graphql/bus/query/busOrdersPage.gql'),
      variables(){
        return{
          page: this.currentPage.toString() || "1",
          orderStatus: this.selectedOrderStatusValue || undefined,
          paymentStatus: this.selectedPaymentValue || undefined,
          campaignStatus: undefined,
          sort: this.selectedSortValue || undefined,
          search: this.searchBoxValue || undefined
        }
      },
      loadingKey:'loading',
      result(data){
        const {busOrdersPage} = data.data
        let result = []
        let busOrders = busOrdersPage.busOrders
        let meta = busOrdersPage.meta
        this.resetData()
        if (busOrders){
          for(let i = 0; i<busOrders.length;i++){
          let statusDisplay = this.getStatusDisplay(busOrders[i].status.titleDisplay)
          let valuesData = [
            { label: busOrders[i].number, value: busOrders[i].id },
            { value: busOrders[i].campaign.companyName },
            { value: busOrders[i].campaign.title},
            { value: parseInt(busOrders[i].campaign.totalPrice) || 0},
            { value: busOrders[i].payment.statusDisplay.toLowerCase(), label: busOrders[i].payment.statusDisplay.toUpperCase() },
            { value: busOrders[i].payment.dueDate ? busOrders[i].payment.dueDate : '' },
            { value: busOrders[i].campaign.start},
            { value: statusDisplay.value, label: statusDisplay.label},
          ]
          result.push({values:valuesData})
        }
        this.data.body = result
        this.maxPage = meta.maxPage
        this.count = meta.count
        }  
      }
    }
  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
    this.$apollo.queries.busOrdersPage.refetch()
    this.data.menu = this.menuOption
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    setItem(item) {
      this.item = item
    },
    selectedProgress(item){
      this.selectedOrderStatusValue = item.value?item.id.toString(): ''
      this.selectedOrderStatusLabel = item.label
    },
    selectedPayment(item){
      this.selectedPaymentValue = item.value
      this.selectedPaymentLabel = item.label
    },
    getProgressList(){
      let pglist = []
      this.progressList.forEach( res => {
        if(res.id != 99){ pglist.push(res)}
      })
      this.bulkAction[0].items= pglist
      this.menuOption[0].items = pglist
    },
    changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
    },
    async resetFilter(){
      this.selectedPage = 1
      this.selectedOrderStatusValue = null,
      this.selectedOrderStatusLabel = null,
      this.selectedPaymentValue = null,
      this.selectedPaymentLabel = null
      await this.$apollo.queries.busOrdersPage.refetch()
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `lead`:
          res = { id: 0, value: 'lead', label: 'LEAD', status: ''}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: 'verified'}
          break
        case `designing`:
          res = { id: 2, value: 'designing', label: 'DESIGNING', status: 'verified'}
          break
        case `designapproval`:
          res = { id: 3, value: 'designapproval', label: 'DESIGN APPROVAL', status: 'designed'}
          break
        case `printing`:
          res = { id: 4, value: 'printing', label: 'PRINTING', status: 'designed'}
          break
        case `printapproval`:
          res = { id:5, value: 'printapproval', label: 'PRINTING APPROVAL', status: 'designed'}
          break
        case `wrapping`:
          res = { id:6, value: 'wrapping', label: 'WRAPPING', status:'designed'}
          break
        case `done`:
          res = { id:7, value: 'done', label: 'DONE', status:'wrapped'}
      }
      return res
    },
    async selectedBulkAction(event, index, id){
      this.refetchLoading = true
      let ids = []

      this.selectedItems.forEach(element => {
        ids.push(parseInt(element));
      });
      
      let valueChange = event.items

      const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/updateStatusByOrderBulk.gql'),
            variables: {
              orderStatus: {
                status: valueChange.id,
                listId: ids
              }
            }
          }
        );
        if (result.data){
          await this.$apollo.queries.busOrdersPage.refetch()
          this.refetchLoading = false
          this.$notify({
            group: 'saved',
            title: 'Change Status',
            text: 'Change Status Saved',
            type: 'success'
          })    
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
          });
        }
    },
    async selected(event, index, id) {
      if (event.items){
        this.refetchLoading = true
        let dataIndex = this.data.body[index]
        let dataDisplay = this.getStatusDisplay(event.items.value)

        let body = { status:dataDisplay.id }
        const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/updateStatusByOrder.gql'),
            variables: {
              id: id.toString(),
              orderStatus: {status:dataDisplay.id}
            }
          }
        );
        if (result.data){
          await this.$apollo.queries.busOrdersPage.refetch()
          this.$notify({
            group: 'saved',
            title: 'Change Status',
            text: 'Change Status Saved',
            type: 'success'
          });
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
          });
        }
        this.refetchLoading = false
      } else {
        const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/mutation/updateNotificationByOrder.gql'),
            variables: {
              id: id,
              orderNotification:{
                is_read:true
              }
            }
          }
        );
        this.$router.push({ name: 'orderdetailexecution', params: { id: id }})
      }
    },
    selectedCheckbox(selectedItems){
      if(selectedItems.length){
        this.isShowBulkAction = true
      } else{
        this.isShowBulkAction = false
      }
      this.selectedItems = selectedItems
    },
    resetData(){
      this.data.body = null
      this.data.body = []
    },
    async selectedRow(item, index){
      let id = item.values[0].value
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateNotificationByOrder.gql'),
        variables: {
          id: id,
          orderNotification:{
            is_read: true
          }
        }
      });
      this.$router.push({ name: 'orderdetailexecution', params: { id: id }})
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.OrderPayment {
  .table {
    table {
      thead {
        tr {
          background-color: #fafafa;
          td {
            span {
              font-size:12px;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            .text {
              font-size:15px;
              max-width: 200px;
              -webkit-line-clamp: 3;
            }
            .date {
              font-size:15px;
              // display: block;
              // text-align: center;
            }
            .money {
              text-align:left;
              span {
                font-size:15px;
              }
            }
          }
        }
      }
    }
	}
}
.standardInput {
  font-size: 15px
}
</style>